import React, {
  ChangeEvent,
  FormEvent,
  useEffect,
  useRef,
  useState,
  type FC,
} from "react";
import classes from "./ReviewModal.module.css";
import BackgroundMovieLayout from "./BackgroundMovieLayout";
import { convertMinutesToHoursAndMinutes } from "../Utils/helpers";
import { animate, motion, useAnimationControls } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { toggleReviewModal } from "../Slices/reviewModalSlice";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import {
  useGetSearchResultsMutation,
  useGetTopResultsQuery,
  usePostReviewMutation,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import Spinner from "./Loaders/Spinner";
import { openViewReviewModal } from "../Slices/viewReviewModalSlice";
import BackgroundLayout from "./BackgroundLayout";
import { togglePostModal } from "../Slices/postModalSlice";
import {
  resetPostTitlesState,
  togglePostTitleModal,
} from "../Slices/postTitlesSlice";
import { fetchedDataType } from "./Drag-Cards/SectionDragCards";
import DragCardsTitle from "./Drag-Cards/DragCardsTitle";
import MovieCard from "./Drag-Cards/MovieCard";
import SkeletonCardsGrid from "./SkeletonCardsGrid";

type PostTitlesModalProps = {};

const PostTitlesModal: FC<PostTitlesModalProps> = () => {
  const controls = useAnimationControls();
  const dispatch = useAppDispatch();

  const [topResults, setTopResults] = useState<[] | fetchedDataType[]>([]);

  const [searchResults, setSearchResults] = useState({
    movies: [],
    series: [],
  });

  const [pageNumber, setPageNumber] = useState<number>(1);

  const [fetchData, setFetchData] = useState<boolean>(false);

  const lastItemRef = useRef<HTMLDivElement | null>(null);

  const [inputValue, setInputValue] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);

  const [windowWidth, setWindowWidth] = useState<number>(0);
  
  const { postTitlesModal, selectedTitles } = useAppSelector(
    (state) => state.postTitlesSlice
  );

  const { data, refetch, isFetching, error } = useGetTopResultsQuery(
    {
      page: pageNumber,
    },
    {
      skip: !postTitlesModal,
    }
  );

  useEffect(() => {
    if (postTitlesModal) {
      controls.start("visible");
      document.body.style.overflow = "hidden";
    }
    // return () => {
    //   document.body.style.overflow = "auto";
    // };
  }, [postTitlesModal]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        console.log(entries[0]?.isIntersecting,'e');
        console.log(postTitlesModal,'ptm')
        if (entries[0]?.isIntersecting && postTitlesModal && !fetchData) {
          console.log("enter here and fetch the data ...");
          if (pageNumber <= 16) {
            console.log("yes passed the check page number is less than 7")
            refetch();
            setFetchData(true);
          }
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [pageNumber, fetchData, postTitlesModal,lastItemRef]);

  useEffect(() => {
    if (fetchData && !isFetching) {
      console.log("enter in 1st check...");
      if (postTitlesModal && data) {
        console.log("enter here... increase pagenumber and set top results as well...")
        setPageNumber((prevValue) => prevValue + 1);
        setTopResults((prevArray) => {
          return prevArray.length > 0 ? [...prevArray, data] : [data];
        });
        setFetchData(false);
      }
    }
  }, [fetchData, postTitlesModal, data, isFetching]);

  useEffect(() => {
    const updateConstraints = () => {
      setWindowWidth(window.innerWidth);
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, []);

  const [postReview, { isLoading }] = usePostReviewMutation();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const { user } = useAppSelector((state) => state.userSlice);

  const closeReviewModal = () => {
    controls.start("hidden");
    dispatch(togglePostTitleModal());
    dispatch(resetPostTitlesState());
  };

  console.log(data,'dd');

  const [searchApi, { isLoading: searchLoading }] =
    useGetSearchResultsMutation();

  console.log(fetchData,'fd')

  useEffect(() => {
    // Clear previous timeout if user is still typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to trigger the API request after 5 seconds of no typing
    const newTimeout: any = setTimeout(() => {
      if (inputValue.trim() !== "") {
        // Call the API after 5 seconds of inactivity
        handleApiRequest();
      }
    }, 1000);

    setTypingTimeout(newTimeout);

    // Cleanup on unmount or when inputValue changes
    return () => clearTimeout(newTimeout);
  }, [inputValue]);

  const handleApiRequest = async () => {
    const response: any = await searchApi({
      body: {
        query: inputValue,
      },
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      toast.error(
        response?.error?.data?.error?.error ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      setSearchResults({
        movies: response?.data?.result?.movies,
        series: response?.data?.result?.series,
      });
    }
  };

  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const submitHandler = () => {
    if (selectedTitles.length === 0) {
      toast.info("ကျေးဇူးပြု၍ 1 မှ 6 အကြားခေါင်းစဉ်များကိုရွေးချယ်ပါ။");
    } else {
      controls.start("hidden");
      dispatch(togglePostTitleModal());
    }
  };

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundLayout>
        <div className={classes.post_review_navbar}>
          <div className={classes.title_container}>
            <p className={classes.category_title}>ပို့စ်တင်ရန် ခေါင်းစဉ်များကို ရွေးပါ။</p>
          </div>
          <div className={classes.btns_container}>
            <button
              className={classes.close_btn}
              type="button"
              onClick={closeReviewModal}
            >
              <i className={`pi pi-times ${classes.close_icon}`} />
            </button>
            <button
              className={classes.close_btn}
              type="button"
              onClick={submitHandler}
            >
              <i className={`pi pi-check ${classes.close_icon}`} />
            </button>
          </div>
        </div>

        <div className={classes.input_form}>
          <i className={`pi pi-search ${classes.search_icon}`} />
          <InputText
            type="text"
            className={classes.search_input}
            value={inputValue}
            onChange={handleInputChange}
            placeholder="ရုပ်ရှင်များ/စီးရီးများကို ရှာဖွေပါ။"
          />
        </div>

        {selectedTitles.length > 0 && (
          <div className={classes.section_drag_cards}>
            <div className={classes.section_cards}>
              <motion.div
                className={classes.section_card}
                style={{
                  gridTemplateColumns: `repeat(${selectedTitles.length}, 150px)`,
                }}
                drag="x"
                dragConstraints={{
                  top: 0,
                  left: -(windowWidth <= 800
                    ? 10 +
                      selectedTitles.length * 150 +
                      selectedTitles.length * 10 +
                      selectedTitles.length * 1 -
                      windowWidth
                    : window.innerWidth * 0.05 +
                      selectedTitles.length * 150 +
                      selectedTitles.length * 10 +
                      selectedTitles.length * 1 -
                      windowWidth),
                  right: 0,
                  bottom: 0,
                }}
                transition={{
                  type: "spring",
                  damping: 100,
                  stiffness: 100,
                }}
              >
                {selectedTitles?.map((data, idx) => {
                  return (
                    <MovieCard
                      key={idx}
                      data={data}
                      type="selected titles and remove dispatch"
                    />
                  );
                })}
              </motion.div>
            </div>
          </div>
        )}

        <div className={classes.section_drag_cards}>
          <div className={classes.section_cards}>
            <div className={classes.category_title_container}>
              <div className={classes.title_container}>
                <p className={classes.category_title}>ထိပ်တန်းရှာဖွေမှုများ</p>
              </div>
            </div>

            {searchLoading ? (
              <SkeletonCardsGrid />
            ) : (searchResults?.movies.length > 0 ||
                searchResults.series.length > 0) &&
              inputValue.trim().length !== 0 ? (
              <>
                {searchResults?.movies.length > 0 && (
                  <motion.div
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${searchResults?.movies.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          searchResults?.movies.length * 150 +
                          searchResults?.movies.length * 10 +
                          searchResults?.movies.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          searchResults?.movies.length * 150 +
                          searchResults?.movies.length * 10 +
                          searchResults?.movies.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {searchResults?.movies?.map((data, idx) => {
                      return (
                        <MovieCard
                          key={idx}
                          data={data}
                          type="select titles and dispatch"
                        />
                      );
                    })}
                  </motion.div>
                )}

                {searchResults?.series.length > 0 && (
                  <motion.div
                    className={classes.section_card}
                    style={{
                      gridTemplateColumns: `repeat(${searchResults?.series.length}, 150px)`,
                    }}
                    drag="x"
                    dragConstraints={{
                      top: 0,
                      left: -(windowWidth <= 800
                        ? 10 +
                          searchResults?.series.length * 150 +
                          searchResults?.series.length * 10 +
                          searchResults?.series.length * 1 -
                          windowWidth
                        : window.innerWidth * 0.05 +
                          searchResults?.series.length * 150 +
                          searchResults?.series.length * 10 +
                          searchResults?.series.length * 1 -
                          windowWidth),
                      right: 0,
                      bottom: 0,
                    }}
                    transition={{
                      type: "spring",
                      damping: 100,
                      stiffness: 100,
                    }}
                  >
                    {searchResults?.series?.map((data, idx) => {
                      return (
                        <MovieCard
                          key={idx}
                          data={data}
                          type="select titles and dispatch"
                        />
                      );
                    })}
                  </motion.div>
                )}
              </>
            ) : (
              <>
                {topResults?.map((data, idx) => {
                  return (
                    <motion.div
                      key={idx}
                      className={classes.section_card}
                      style={{
                        gridTemplateColumns: `repeat(${topResults[idx]?.result?.results?.length}, 150px)`,
                      }}
                      drag="x"
                      dragConstraints={{
                        top: 0,
                        left: -(windowWidth <= 800
                          ? 10 +
                            topResults[idx]?.result?.results.length * 150 +
                            topResults[idx]?.result?.results.length * 10 +
                            topResults[idx]?.result?.results.length * 1 -
                            windowWidth
                          : window.innerWidth * 0.05 +
                            topResults[idx]?.result?.results.length * 150 +
                            topResults[idx]?.result?.results.length * 10 +
                            topResults[idx]?.result?.results.length * 1 -
                            windowWidth),
                        right: 0,
                        bottom: 0,
                      }}
                      transition={{
                        type: "spring",
                        damping: 100,
                        stiffness: 100,
                      }}
                    >
                      {data?.result?.results?.map((dataItem, idx2) => (
                        <MovieCard
                          key={`${idx}-${idx2}`}
                          data={dataItem}
                          type="select titles and dispatch"
                        />
                      ))}
                    </motion.div>
                  );
                })}

                {isFetching && <SkeletonCardsGrid />}
              </>
            )}

            {pageNumber >= 16 ? null : (
              <div ref={lastItemRef} className={classes.load_item}></div>
            )}
          </div>
        </div>
      </BackgroundLayout>
    </motion.div>
  );
};

export default PostTitlesModal;
